import { defaultMain } from '@/router/index';
// import { teams } from '@/modules/Team/routes.js';
import { events, eventsStock, eventAssociations, uiEventsStockDashboard } from '@/modules/Events/routes.js';
import { uiEventPlan } from '@/modules/EventsPlan/routes';
import { analytics, uiAnalytics } from '@/modules/Analytics/routes.js';
import { profileHistory, myProfile } from '@/modules/Profile/routes.js';
import { tools, settings } from '@/modules/Settings/routes.js';
import { mailing } from '@/modules/Mailing/routes.js';
import { documents } from '@/modules/Documents/routes.js';
import {
  userLogin,
  userRecovery,
  allDuplicatePage,
  eventsPage,
  eventTemplates,
  eventGlobalAttributesPage,
  adminEventAssociations,
  operatorLogin,
  adminEventRecommendations,
} from '@/modules/Admin/routes.js';
import { partners } from '@/modules/Partners/routes.js';
// import { exhibitions } from '@/modules/EventExhibition/routes';
import { eventCreate, eventsOrganizer, eventsSearch } from '@/modules/UIDesign/Events/routes';

import { mapGetters } from 'vuex';
import { uiPersonal } from '@/modules/UIDesign/Staff/routes';
import { uiGiftedChildrenMain, uiGiftedChildrenRegistry } from '@/modules/UIDesign/GiftedChildren/routes';
import { uiGrandingAssigment } from '@/modules/Poll/routes';
import { uiPartnersMain } from '@/modules/UIDesign/Partners/routes';
import { uiInstructions } from '@/modules/UIDesign/Instructions/routes';
import { trainerEvents, clubsList, myTeams, trainerAssociations } from '@/modules/UIDesign/Club/routes';
import { withoutNavigationRoutes } from '@/modules/UserEvents/routes';
import { resultRoute } from '@/modules/UserProfile/routes';
import { adminEventsDashboard, adminUsersDashboard } from '@/modules/UIDesign/Admin/routes';

export default {
  computed: {
    ...mapGetters({
      hasEventAssociations: 'auth/hasEventAssociations',
    }),
    navigationParticipant() {
      return [
        defaultMain,
        // events,
        // // teams,
        // profileHistory,
        // // myProfile,
        ...withoutNavigationRoutes,
        eventsSearch,
        resultRoute,

      ];
    },
    navigationOrganization() {
      return [
        defaultMain,
        uiEventPlan,
        eventsOrganizer,
        uiEventsStockDashboard,
        eventCreate,
        uiPersonal,
      ];
    },
    navigation() {
      return {
        certificate: this.navigationParticipant,
        member: this.navigationParticipant,
        trainer: [
          {
            ...defaultMain,
            meta: {
              ...clubsList.meta,
            },
          },
          myTeams,
          trainerEvents,
          eventsSearch,
          trainerAssociations,
        ],
        organizations: [
          ...this.navigationOrganization,
          // defaultMain,
          // tools,
          // eventPlan,
          // exhibitions,
          // ...(this.hasEventAssociations ? [eventAssociations] : []),
          // events,
          // eventsStock,
          // personal,
          // analytics,
          // myProfile,
        ],
        department: [
          defaultMain,
          // uiEventPlan,
          uiAnalytics,
          uiGiftedChildrenRegistry,
        ],
        operators: [
          defaultMain,
          // uiEventPlan,
          uiGiftedChildrenMain,
          uiAnalytics,
          // settings,
          // mailing,
        ],
        admins: [
          defaultMain,
          userLogin,
          adminUsersDashboard,
          adminEventsDashboard,
          // userRecovery,
          // allDuplicatePage,
          // eventsPage,
          // eventTemplates,
          // eventGlobalAttributesPage,
          adminEventAssociations,
          // adminEventRecommendations,
          // operatorLogin,
        ],
        expert: [
          defaultMain,
          uiGrandingAssigment,
          // uiPartnersMain,
          // myProfile,
        ],
        moderator: [defaultMain],
        event_manager: [defaultMain, events],
        guest: [
          {
            ...defaultMain,
            meta: {
              ...defaultMain.meta,
              buttonTitle: 'Найди своё мероприятие',
            },
          },
          // uiInstructions,
        ],
      };
    },
  },
};
